<template lang="pug">
b-modal#editBoDefaultDomain(
  ref="editBoDefaultDomain"
  :title="$t('ui.combine.edit_bo_default_domain')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.domain_name')").mb-1
      DebounceInput(
        size="sm"
        ref="domain_name"
        required
        type="text"
        :dirty="$v.domain_name.$dirty"
        :error="$v.domain_name.$error"
        v-model.trim.lazy="$v.domain_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.domain_name" :name="$t('ui.domain_name')")
    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      domain_id: "",
      domain_name: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    domain_name: {
      required,
      isDomain: function(str) {
        var regexp = /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/i;

        if (regexp.test(str))
        {
          return true;
        }
        else
        {
          return false;
        }
      }
    }
  },
  methods: {
    done(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editBoDefaultDomainUrl();
        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          domain_name: this.domain_name,
          domain_id: this.domain_id
        };
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_bo_default_domain", this.feedback.status);
                }
                this.$nextTick(() => {
                  this.$refs.editBoDefaultDomain.hide();
                });
              }
            } catch (error) {
              this.loading = false;
              if (error.status.toLowerCase() == "nochanges") {
                this.$emit("clicked");
                this.$nextTick(() => {
                  this.$refs.editBoDefaultDomain.hide();
                });
              } else {
                this.feedback.success = false;
                this.feedback.status = error.status;
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = response.data.status;
            this.$helpers.handleFeedback(this.feedback.status);
          }
        );
      }
    },
    reset() {
      this.domain_id = "";
      this.domain_name = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.domain_id = this.item.domain_id;
      this.domain_name = this.item.domain_name;
      this.$refs.domain_name.$el.focus();
    }
  }
};
</script>
